import React from 'react';
import { AlertCircle } from 'lucide-react';

interface FailedCountBannerProps {
  message: string;
}

const FailedCountBanner: React.FC<FailedCountBannerProps> = ({ message }) => (
  <div
    role="note"
    className="mx-4 mt-4 md:mx-6 md:mt-6 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-gray-900"
  >
    <AlertCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600" aria-hidden="true" />
    <p>{message}</p>
  </div>
);

export default FailedCountBanner;
